import { debounce } from 'throttle-debounce';

export const scaleBlockToScreen = (videoBlock, position = 'absolute', wrapperToScale = null) =>  {

	const updateBlock = () => {
		const windowWidth = wrapperToScale ? wrapperToScale.offsetWidth : window.innerWidth;
		const windowHeight = wrapperToScale ? wrapperToScale.offsetHeight : window.innerHeight;
		const windowRatio = windowWidth / windowHeight;
		const videoRatio = 16 / 9;

		if (windowRatio > videoRatio) {
			videoBlock.style.width = windowWidth + 'px';
			videoBlock.style.height = (windowWidth / videoRatio) + 'px';
		}
		else {
			videoBlock.style.width = (windowHeight * videoRatio) + 'px';
			videoBlock.style.height = windowHeight + 'px';
		}

		console.log('position', position)
		if (position === 'fixed') {
			videoBlock.style.position = 'fixed';
		} else if (position === 'absolute') {
			videoBlock.style.position = 'absolute';
		} else if (position === 'relative') {
			videoBlock.style.position = 'relative';
		}

		if (position !== 'relative') {
			videoBlock.style.left = '50%';
			videoBlock.style.top = '50%';
			videoBlock.style.transform = 'translate(-50%, -50%)';
		}
	};
	window.addEventListener('resize', debounce(200, updateBlock));

	updateBlock();
};
